import "core-js/stable";
import $ from "jquery";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import "./shared/langSelect";
import "./shared/importFonts";
import "../styles/login.scss";
var loginForm = document.getElementById("loginForm");
var metaData = document.getElementById("metaData");

// Invisible form fields
var inputOk = document.getElementById("inputOk");
var inputPasswordReset = document.getElementById("inputPasswordReset");
var inputUsernameRecovery = document.getElementById("inputUsernameRecovery");

// Form Links
var linkForgotPassword = document.getElementById("linkForgotPassword");
var linkRecoverUsername = document.getElementById("linkRecoverUsername");

// Form buttons
var buttonSignOn = document.getElementById("buttonSignOn");
function validForm() {
  var errors = 0;
  if (!loginForm.checkValidity()) {
    errors++;
  }
  loginForm.classList.add('was-validated');
  return errors === 0;
}
function submitForm() {
  buttonSignOn.innerHTML = metaData.getAttribute("data-signing-on-text");
  buttonSignOn.disabled = true;
  inputOk.value = "clicked";
  loginForm.submit();
  // CaptchaManager requires 'assets/scripts/captcha/captcha-utils.js' to be loaded on the page first.
  CaptchaManager.cleanup();
}

//Disable default form submit
loginForm.addEventListener("submit", function (e) {
  e.preventDefault();
  e.stopPropagation();
  if (validForm()) {
    // CaptchaManager requires 'assets/scripts/captcha/captcha-utils.js' to be loaded on the page first.
    CaptchaManager.execute(function () {
      submitForm();
    });
  }
});

// Navigate to Forgot Password page.
if (linkForgotPassword !== null) {
  linkForgotPassword.addEventListener("click", function (e) {
    inputPasswordReset.value = "clicked";
    loginForm.submit();
  });
}

// Navigate to Username Recovery page.
if (linkRecoverUsername !== null) {
  linkRecoverUsername.addEventListener("click", function (e) {
    inputUsernameRecovery.value = "clicked";
    loginForm.submit();
  });
}

// Add to global scope for captcha callback.
window.submitForm = submitForm;